module.exports = __webpack_public_path__ + "static/media/Kit_Back_Site.de3671b0.jpg";